// extracted by mini-css-extract-plugin
module.exports = {"body":"PageSwitch_body__hkQd1"};